import {
  GET_ALL_HIPPODROMES,
  GET_ALL_HIPPODROMES_SUCCESS,
  GET_ALL_HIPPODROMES_FAILURE,
  TOGGLE_TJK_TV,
  SET_PROGRAM_TYPE,
  FIXED_ODD_CHANGE
} from 'Store/constants';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';


const initialState = {
  data: [],
  isLoading: true,
  showTjkTv: false,
  error: null,
  programType: PROGRAM_TYPES.JOINT,
  changedOdd: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_HIPPODROMES:
      return { ...state, isLoading: true, error: null };
    case GET_ALL_HIPPODROMES_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_ALL_HIPPODROMES_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case TOGGLE_TJK_TV:
      return { ...state, showTjkTv: action.payload };
    case SET_PROGRAM_TYPE:
      return { ...state, programType: action.payload };
    case FIXED_ODD_CHANGE:
      return { ...state, changedOdd: action.payload };
    default:
      return state;
  }
};
